import { UseQueryResult } from "@tanstack/react-query"
import { Audience } from "../../interfaces/Campaign.interface"
import { DefaultOptionType } from "antd/es/select"

export function audienceQueryToSelectOptions(query: UseQueryResult<Audience[] | null, Error>): DefaultOptionType[] | undefined {
    return query.data?.map(aud => {
        return {
            label: `${aud.name} (${aud.estimatedReach})`,
            value: aud.id
        }
    }) ?? []
}